exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".communication-media-upload{margin-bottom:30px;margin-top:30px;max-width:100%}", ""]);

